import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTab(0)
  }

  disconnect() {
    this.tabTargets.forEach(tab => tab.removeEventListener("click", this._boundSwitch))
  }

  switch(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("border-accent", "text-accent-ink")
        tab.classList.remove("border-transparent", "text-ink-subtle", "hover:text-ink-muted", "hover:border-line")
      } else {
        tab.classList.remove("border-accent", "text-accent-ink")
        tab.classList.add("border-transparent", "text-ink-subtle", "hover:text-ink-muted", "hover:border-line")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })

    // Highlight code in the newly visible panel if not already done
    if (typeof hljs !== "undefined") {
      const panel = this.panelTargets[index]
      panel.querySelectorAll("pre code:not(.hljs)").forEach((block) => {
        hljs.highlightElement(block)
      })
    }
  }
}
